import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  display: flex;
  gap: 10px;
`;

export default Wrapper;
